import { MAX_FILE_SIZE_IN_BYTES } from '../constants/maxFileSizeInBytes'

export const getIsFileSizeExceeded = (fileSize?: number) => Boolean(fileSize && fileSize > MAX_FILE_SIZE_IN_BYTES)
